module.exports = "https://web-assets.ifttt.com/packs/media/service_icons/twitter-6f7fc4c1.svg";